export const AccordionHeaderParamsTexts = {
  HeaderDefaultTitle: 'Работа',
  HeaderDefaultDescription: 'Заполните данные',
};
